import { Col, Row } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import CustomCard from '../../../components/Antd/Card';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomLink from '../../../v2-components/Antd/Link';
import { CustomNotification } from '../../../v2-components/Notification';
import { LOCAL_STORAGE } from '../../../v2-config/constants/local-storage.constant';
import { Service } from '../service';
import usePharmacyStore from './store/pharmacy-store';
import './style.scss';
import Loading from '../../../v2-components/Loading';

export default function PharmacySliderTemplatesPage() {
	const [loading, setLoading] = useState(true);
	const { pharmacy, platform: ecosystem, token } = GetLocalStorageValue(LOCAL_STORAGE.USER);
	const [pharmacyLocations, setPharmacyLocations, setSelectedPharmacy, setPlatform, setEcosystem, setToken] = usePharmacyStore((state) => [
		state.pharmacyLocations,
		state.setPharmacyLocations,
		state.setSelectedPharmacy,
		state.setPlatform,
		state.setEcosystem,
		state.setToken,
	]);

	useEffect(() => {
		setPharmacyLocations([]);
	}, [setPharmacyLocations]);

	useEffect(() => {
		setSelectedPharmacy(pharmacy);
		setEcosystem(ecosystem);
		setToken(token);
		new Service()
			.getAllTemplates(pharmacy, ecosystem)
			.then((templatesResponse) => {
				setPharmacyLocations(templatesResponse);
				setPlatform(templatesResponse[0].platform);
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				CustomNotification({ type: 'error', description: 'Ha ocurrido un error al obtener los recursos:', message: error });
			});
	}, [pharmacy, setPharmacyLocations, setSelectedPharmacy, setPlatform, ecosystem, setEcosystem, setToken, token]);

	if (loading) {
		return <Loading />;
	}

	return (
		<div className="pharmacy-sliders-template">
			<h1>Configuración de espacios publicitarios</h1>
			{pharmacyLocations?.length > 0 ? (
				<>
					<h2>Seleccionar página a editar</h2>
					<Row gutter={[16, 16]}>
						{pharmacyLocations.map((iterator, key) => {
							return (
								<Fragment key={key}>
									<Col md={8} xs={24}>
										<CustomLink className="card-link" to={`/v2/pharmacy-sliders/templates/${iterator.template}`}>
											<CustomCard
												className="pharmacy-sliders-cards"
												title={
													<div className="card-header-container">
														<h3>{iterator.label}</h3>
														<div className="inner-container">
															<p>{iterator.modules.length} elementos configurables</p>
														</div>
													</div>
												}
											>
												<CustomImage src={iterator.img_cover} alt="img" preview={false} />
											</CustomCard>
										</CustomLink>
									</Col>
								</Fragment>
							);
						})}
					</Row>
				</>
			) : (
				<h2>Elija una plataforma para ver las páginas editables</h2>
			)}
		</div>
	);
}
